import { useState } from 'react'
import { Link, useParams } from '@tanstack/react-router'
import { Archive } from 'lucide-react'
import { Input, PageHeader, SkeletonRows, Table, Td, Tr } from '@/components/ui'
import { EmptyState, ErrorState, StageBadge } from '@/components/status'
import { dateTime } from '@/lib/format'
import { FINISHED, useBoard } from '@/features/shell/useOverview'
import { prUrl, useProject } from './Overview'

/** Finished workspaces (merged, dropped, archived). Read-only history. */
export function ArchivePage() {
  const { project } = useParams({ strict: false }) as { project: string }
  const [q, setQ] = useState('')
  // The board holds every workspace; the archive is the finished ones.
  const { data: board, error, refetch } = useBoard(project)
  const repo = useProject(project).data
  const data = board?.workspaces.filter((w) => FINISHED.has(w.stage))
  const rows = (data ?? []).filter((w) => !q || `${w.ticket} ${w.title}`.toLowerCase().includes(q.toLowerCase()))
  return (
    <div>
      <PageHeader title="Archive" meta="Merged, integrated and dropped workspaces." actions={<Input placeholder="Filter…" value={q} onChange={(e) => setQ(e.target.value)} className="h-7 w-56 text-xs" />} />
      {error && !data ? <ErrorState error={error} retry={() => void refetch()} /> : !data ? <SkeletonRows rows={8} /> : rows.length === 0 ? (
        <EmptyState icon={<Archive size={20} />} title={q ? 'Nothing matches' : 'Nothing archived yet'} body={q ? undefined : 'A workspace lands here once its PR merges or it is dropped.'} />
      ) : (
        <Table head={['Ticket', 'Title', 'Stage', 'PR', 'Finished']}>
          {rows.map((w) => (
            <Tr key={w.id}>
              <Td mono><Link to="/p/$project/w/$ticket" params={{ project, ticket: w.ticket }} className="text-accent-hover hover:underline">{w.ticket}</Link></Td>
              <Td className="max-w-md truncate">{w.title}</Td>
              <Td><StageBadge stage={w.stage} /></Td>
              <Td>{w.prNumber != null ? <a href={prUrl(repo, w.prNumber)} target="_blank" rel="noopener noreferrer" className="text-accent-hover hover:underline">#{w.prNumber}</a> : '—'}</Td>
              <Td className="text-xs text-fg-subtle">{dateTime(w.updatedAt)}</Td>
            </Tr>
          ))}
        </Table>
      )}
    </div>
  )
}
